<template>
  <div class="login-page">
    <authorization-layout>
      <h1 class="authorization-form__header">
        Zaloguj się
      </h1>

      <v-form
        ref="loginForm"
        v-model="isFormValid"
        class="mt-3"
        lazy-validation
        @submit.prevent="submitForm"
      >
        <div class="authorization-form__label">
          Adres e-mail
        </div>

        <v-text-field
          v-model.trim="user.email"
          class="authorization-form__field"
          :rules="[rules.required, rules.email]"
          v-bind="props.validatedField"
          placeholder="Wprowadź adres e-mail..."
        />

        <div class="authorization-form__label">
          Hasło
        </div>

        <v-text-field
          v-model.trim="user.password"
          class="authorization-form__field"
          :rules="[rules.required]"
          v-bind="props.validatedField"
          type="password"
          placeholder="Wprowadź hasło..."
        />

        <div class="d-flex align-center justify-space-between">
          <v-checkbox
            v-model="isRememberMeChecked"
            class="mt-0 pt-0"
            dense
            hide-details
          >
            <template #label>
              <span class="authorization-form__checkbox-label">Zapamiętaj mnie</span>
            </template>
          </v-checkbox>

          <span
            class="authorization-form__lost-password"
            @click="displayPasswordReminder"
          >
            Przypomnij hasło
          </span>
        </div>

        <v-btn
          class="custom-submit-button"
          color="primary"
          block
          depressed
          :loading="isProcessing"
          type="submit"
          height="40"
        >
          Zaloguj się
        </v-btn>
      </v-form>
    </authorization-layout>
  </div>
</template>

<script>
import AuthorizationLayout from '@/components/Layout/AuthorizationLayout.vue';
import validationRules from '@/helpers/validators';
import props from '@/helpers/componentsProps';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    AuthorizationLayout,
  },

  data() {
    return {
      rules: validationRules,
      props,
      isFormValid: true,
      isRememberMeChecked: false,
      user: {
        password: process.env.VUE_APP_PASSWORD || '',
        email: process.env.VUE_APP_EMAIL || '',
      },
    };
  },

  computed: {
    ...mapState('auth', [
      'isProcessing',
    ]),
  },

  methods: {
    displayPasswordReminder() {
      this.showDialog({
        header: 'Odzyskiwanie hasła',
        text: 'Na podany adres e-mail istniejącego konta dostaniesz instrukcję z dalszymi etapami odzyskiwania hasła.',
        component: 'RememberPassword',
      });
    },

    submitForm() {
      this.$refs.loginForm.validate();
      if (this.isFormValid) {
        const { email, password } = this.user;
        const caseInsensitiveEmail = email.toLowerCase();

        const loginParams = {
          password,
          email: caseInsensitiveEmail,
          remember: this.isRememberMeChecked,
        };
        this.login(loginParams);
      }
    },
    ...mapActions('dialog', [
      'showDialog',
    ]),
    ...mapActions('auth', [
      'login',
    ]),
  },
};
</script>
